import { PropsWithChildren, useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  ZeroPaddingAccordion,
  ZeroPaddingAccordionDetails,
  ZeroPaddingAccordionSummary,
} from "./AccordionMessage.styles";
import { MessageLoading } from "../../MessageLoading";
import { Typography } from "@avenue-8/sidekick-ui";

export const AccordionMessage = (
  props: PropsWithChildren<{
    title: string;
    finishedReasoning?: boolean;
    loading?: boolean;
    isActive?: boolean;
    defaultOpen?: boolean;
    onExpandChange?: (expanded: boolean) => void;
  }>,
) => {
  const {
    title,
    children,
    finishedReasoning,
    loading,
    isActive,
    defaultOpen,
    onExpandChange,
  } = props;
  const [isOpen, setIsOpen] = useState(defaultOpen ?? false);

  const isContextTitle = finishedReasoning === true;

  const handleChange = (_e: React.SyntheticEvent, expanded: boolean) => {
    setIsOpen(expanded);
    onExpandChange?.(expanded);
  };

  return (
    <ZeroPaddingAccordion
      slotProps={{
        transition: {
          unmountOnExit: true,
          onEntered: (node) => {
            node.scrollIntoView({ behavior: "smooth", block: "nearest" });
          },
        },
      }}
      elevation={0}
      expanded={isOpen}
      onChange={loading ? undefined : handleChange}
    >
      <ZeroPaddingAccordionSummary
        expandIcon={loading ? null : <ArrowDropDownIcon />}
        aria-controls="context-message-content"
        id="context-message-header"
        sx={loading ? { cursor: "default", pointerEvents: "none" } : undefined}
      >
        {isContextTitle ? (
          <Typography variant="button" sx={{ color: "text.brand" }}>
            {title}
          </Typography>
        ) : loading || isActive ? (
          <MessageLoading messages={[title]} displayMessageDuration={false} />
        ) : (
          <Typography fontWeight={700} sx={{ color: "text.brand" }}>
            {title}
          </Typography>
        )}
      </ZeroPaddingAccordionSummary>
      <ZeroPaddingAccordionDetails>{children}</ZeroPaddingAccordionDetails>
    </ZeroPaddingAccordion>
  );
};
